import { isUrlInDomainList } from '@/hooks/useRequiredInterceptor';
import { SSO_ANTI_CACHE } from '@/utils/constants';
import { syncGntcConfig } from '@/utils/syncGntcConfig';
import axios from 'axios';
import React from 'react';

export const useAuthHeaderInterceptor = ({
  authToken,
  trustedDomains,
}: {
  authToken: string | null;
  trustedDomains: string[];
}) => {
  const authTokenRef = React.useRef<string | null>(null);

  // Update Reference used inside interceptor
  React.useEffect(() => {
    authTokenRef.current = authToken;
  }, [authToken]);

  // Interceptor
  React.useEffect(() => {
    const ejectId = axios.interceptors.request.use((config) => {
      if (!isUrlInDomainList(config.url, trustedDomains)) return config;

      const { headers = {} } = config;

      if (authTokenRef.current) {
        headers.Authorization = `Bearer ${authTokenRef.current}`;
      }

      return {
        ...config,
        url: SSO_ANTI_CACHE ? `${config.url}?antiCache=${Date.now()}` : config.url,
        headers,
      };
    });

    syncGntcConfig();

    return () => {
      axios.interceptors.request.eject(ejectId);
      syncGntcConfig();
    };
  }, [trustedDomains]);
};
